import { actionCreator } from 'utils';
import {
    SET_PACKAGING_PAGINATION,
    LOAD_PACKAGING,
    RESET_PACKAGING_FILTERS,
    SET_PACKAGING_FILTERS,
    CLOSE_ORDER_ITEM,
    SET_PACKAGING_IS_CLOSED,
    SET_PACKAGING_SORT,
} from '../types/packagingTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    isClosingOrderItem: false,
    isClosed: true,
    offset: 0,
    limit: 50,
    
    sort: {
        key: 'created_at',
        type: 'desc',
    },

    filters: {
        orderItemId: '',
        poNumber: '',
        formId: '',
        jobId: '',
        formVersionId: '',
        customer: '',
        carpetQuality: '',
        carpetDimension: '',
        palettes: '',
        totalQuantity: '',
        quantityPrinted: '',
        startDate: undefined,
        status: undefined,
        steps: undefined,
        expectedFinishDate: undefined,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_PACKAGING:
        return Object.assign({}, state, {
            loading: true,
        });
    case actionCreator(LOAD_PACKAGING, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });
    case actionCreator(LOAD_PACKAGING, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_PACKAGING_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_PACKAGING_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_PACKAGING_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case RESET_PACKAGING_FILTERS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: initState.filters,
        });

    case actionCreator(RESET_PACKAGING_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case CLOSE_ORDER_ITEM:
        return Object.assign({}, state, {
            isClosingOrderItem: true,
        });

    case actionCreator(CLOSE_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            isClosingOrderItem: false,
        });

    case actionCreator(CLOSE_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            isClosingOrderItem: false,
        });

    case SET_PACKAGING_IS_CLOSED:
        return Object.assign({}, state, {
            isClosed: action.data,
        });

    case SET_PACKAGING_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    default:
        return state;
    }
}
